/**
 * Product Domain Bridge Session Page
 * 10-step flow: Product Context → Product Mechanics → Current Performance → Baseline → Future Target
 * → Product Entropy → Heat Map → Bridge Focus → Define Transition → Bridge Card → Control.
 */
import React from 'react';
import { useParams } from 'react-router-dom';
import { BridgeSessionProvider } from '../contexts/BridgeSessionContext';
import { BridgeSessionLayout } from '../components/BridgeSession/BridgeSessionLayout';
import styles from './BridgeSession/BridgeSessionPage.module.css';

export const ProductDomainBridgeSessionPage: React.FC = () => {
  const { sessionId } = useParams<{ sessionId: string }>();

  return (
    <BridgeSessionProvider
      initialSessionId={sessionId}
      sessionType="product"
    >
      <div className={styles.bridgeSessionPage}>
        <BridgeSessionLayout sessionId={sessionId} sessionType="product" />
      </div>
    </BridgeSessionProvider>
  );
};

export default ProductDomainBridgeSessionPage;
